import React from 'react';
import PropTypes from 'prop-types';
import { AuthProvider } from '../auth/Auth0Context';

export const AuthViewModel = (props) => {
  const { children } = props;
  return <AuthProvider>{children}</AuthProvider>;
};

AuthViewModel.propTypes = {
  children: PropTypes.node,
};
